<template>
	<div class="w-100 p-3 bg-white border-15 h-center">
		<div class="w-100 overflow-hidden">
		<div class="row">
			<div class="col-12">
				<textareaInput 
				:value="val.message"
				@inputTxtFunc="(e)=>{val.message = e}"
				label="پیام شما"
				placeholder="پیام خود را در به صورت کامل در این قسمت بنویسید."
				/>
			</div>
			<div class="col-12" style="padding-top: 1rem;">
				<div class="w-100 d-flex align-items-center justify-content-between">
					<label class="mb-2">
						ضمیمه فایل (اختیاری)
					</label>
				</div>
				<file_cloud_lg
				:error="false"
				:files="val.files"
				@chengeFile="(e) => { uploadTF(e)  }"
				@removeFile="(e) => { log('removeFile',e) }"
				label="بارگذاری فایل ها"
				label_sm="حداکثر حجم مجاز : 30 مگابایت"
				/>
			</div>
			<div class="col-12" style="padding-top: 1rem;">
				<btn
					class="w-100"
					textClass="w-100"
					text="ذخیره"
					@clickMe="sav()"
					:disable = "(val.message=='')"
					disableText="اطلاعات را تکمیل نمایید"
				/>
			</div>
		</div>
		</div>
	</div>
</div>
</template>

<script>
	import btn from  "../../UI/button/btn.vue";
	import textareaInput from  "../../UI/input/textareaInput.vue";
	import selectInput from  "../../UI/input/selectInput.vue";
	import file_cloud_lg from  "../../UI/uploadFile/file_cloud_lg.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";
	import * as importances_json from  "../ticket_list/importances.json";
	


	export default {
		name: 'ticket_create_part1',
		data(){
			return {
				loading: loading,
				success_sm: success_sm,
				success: success,
				error: error,
				val : {
					'message': '',
					'files': [],
				},
				importances: importances_json.default
			}
		},
		components: {
			btn,
			selectInput,
			textareaInput,
			file_cloud_lg,
		},
		props: {
			flds: {
				default: [],
			},
		},
		mounted(){
		},
		methods:{
			//***************************************************
			uploadTF(e, THIS = this) {
				THIS.loading(THIS)
				var format =  ["jpg", "jpeg", "png", "pdf", "mp4"];
				var idImg =  "t_[DATE]_[RANDOM]";
				var formData = new FormData();
				formData.append("file", e);
				formData.append("format",format);
				formData.append("idImg", idImg);
				var xhttp = new XMLHttpRequest();
				xhttp.open("POST", window.upldurl, true);
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						THIS.success_sm(THIS)
						this.getVar = JSON.parse(this.responseText);
						var file = {"fileName": this.getVar.filename, "fileUpload": this.getVar.uploadFileName};
						THIS.val.files.push(file);
					}
				};
				xhttp.send(formData);
			},
			//***************************************************
			sav(THIS = this){
				window.$.post(window.baseurl+'ticket/'+this.$route.params.id, {
					status: 'anser',
					val: this.val, 
					token: this.$localStorage.get("user")
				}, function(D){
					THIS.success(THIS);
					THIS.$emit('loader', D);
					THIS.val = {
						'message': '',
						'files': [],
					}
				}, "json");
			},
		}
	}
</script>
